import { createContext } from "react";
import { useState } from "react";

const ExpertDataContext = createContext({
  expertData: {}
});

export const ExpertDataProvider = ({ children }) => {
  const [expertData, setExpertData] = useState({});

  const expertDataAction = (propertyName, newValue) => {
    setExpertData({ ...expertData, [propertyName]: newValue });
  };

  const expertDataRemovePropertyAction = (data) => {
    setExpertData(data)
  }

  const resetExpertDataContext = () => setExpertData({})

  return (
    <ExpertDataContext.Provider
      value={{
        expertData,
        expertDataAction,
        expertDataRemovePropertyAction,
        resetExpertDataContext
      }}
    >
      {children}
    </ExpertDataContext.Provider>
  );
};

export default ExpertDataContext;
